import React, { FC } from 'react';

import { Box, Card, CardContent, Divider, Typography } from '@mui/material';

import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ReceiptIcon from '@mui/icons-material/Receipt';

import { BackflowJobGroup } from '../../model';

interface JobDetailsCardProps {
  backflowJobGroup: BackflowJobGroup;
}

const JobDetailsCard: FC<JobDetailsCardProps> = (props) => {
  const { backflowJobGroup } = props;

  return (
    <Card elevation={3} sx={{ height: '100%' }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <ReceiptIcon color="primary" sx={{ mr: 1 }} />
          <Typography variant="h6" fontWeight="600">
            Job Details
          </Typography>
        </Box>

        <Divider sx={{ mb: 3 }} />

        <Box sx={{ mb: 3 }}>
          <Box display="flex" alignItems="flex-start" mb={2}>
            <Typography variant="body2" fontWeight="500" sx={{ minWidth: 160 }}>
              Order #:
            </Typography>
            <Typography variant="body2">{backflowJobGroup.order_no}</Typography>
          </Box>

          <Box display="flex" alignItems="flex-start" mb={2}>
            <BusinessIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
            <Box>
              <Typography variant="body2" color="text.secondary" fontSize="0.75rem">
                Customer
              </Typography>
              <Typography variant="body1" fontWeight="500">
                {backflowJobGroup.company_name}
              </Typography>
            </Box>
          </Box>

          <Box display="flex" alignItems="flex-start" mb={2}>
            <LocationOnIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
            <Box>
              <Typography variant="body2" color="text.secondary" fontSize="0.75rem">
                Address
              </Typography>
              <Typography variant="body1">{backflowJobGroup.address1}</Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default JobDetailsCard;
